export const CARD = 'card';
export const LAND = 'land';
export const HERO = 'hero';
export const SOUL = 'soul';
